module.exports = __webpack_public_path__ + "static/2front-marketing-2-8357443bc1a3d1d2bad9ccb5002e264c.png";